import { Component, OnInit, } from '@angular/core';
import { NavController, ToastController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContribuicoesProvider } from 'src/app/services/contribuicoes/contribuicoes';
import { Clipboard } from '@capacitor/clipboard';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { MoneyPipe } from 'src/app/pipes/money/money';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
@Component({
  selector: 'app-contribuicoes-contas-bancarias',
  templateUrl: './contribuicoes-contas-bancarias.page.html',
  styleUrls: ['./contribuicoes-contas-bancarias.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SemRegistroComponent,
    MoneyPipe,
    TranslateModule,
    LoadingSpinnerComponent
  ],
})
export class ContribuicoesContasBancariasPage implements OnInit {
  contas: any = [];
  texto: any;
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public contribuicoesController: ContribuicoesProvider,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public navParams: NavParams
  ) {
    this.texto = this.navParams.get('texto');
    this.contribuicoesController.getContasBancarias().subscribe({
      next: (data) => {
        this.contas = data;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro:", err);
        this.loaded = true;
      },
    });
  }

  ngOnInit() {
  }

  async copiar(valor: string) {
    await Clipboard.write({
      string: valor
    });

    let toast = await this.toastCtrl.create({
      message: this.translate.instant('Copiado com sucesso'),
      duration: 4000
    });
    toast.present();
  }

  public closeModal(){
    this.modalCtrl.dismiss();
  }
}
